<template>
    <div>
        <HeaderSection icon="fal fa-frown" title="Error 404">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <el-row>
            <el-col>
                <h4>La página a la que intenta acceder no existe.</h4>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import HeaderSection from '@/components/partials/HeaderSection';
    export default {
        components: {
            HeaderSection,
        },
    }
</script>

<style scoped>

</style>
